export function Settings(){
    return (
            <div id="settings">
                <h1>PROGRESS BINAURAL APP 1.0</h1>
            </div>
    );
}
